import { render } from "./Field3D.vue?vue&type=template&id=254d573d"
import script from "./Field3D.vue?vue&type=script&lang=js"
export * from "./Field3D.vue?vue&type=script&lang=js"

import "./Field3D.vue?vue&type=style&index=0&id=254d573d&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__